import * as React from 'react'

import cn from 'classnames'

import Separator from 'modules/core/components/Separator'

import * as styles from './index.vanilla.css'

type Types = 'brand' | 'primary' | 'negative'
interface Props {
  compact?: boolean
  color?: string
  subtitle?: string
  label?: React.ReactNode
  type?: Types
  separator?: boolean
  centered?: boolean
}

const Title = ({ compact, color, centered, label, subtitle, separator, type }: Props) => {
  const titleClassName = compact ? styles.titleCompact : styles.title
  const titleTypeClass =
    type === 'brand'
      ? styles.titleBrand
      : type === 'primary'
        ? styles.titlePrimary
        : type === 'negative'
          ? styles.titleNegative
          : styles.titleBrand

  const subtitleTypeClass =
    type === 'brand'
      ? styles.subtitleBrand
      : type === 'primary'
        ? styles.subtitlePrimary
        : type === 'negative'
          ? styles.subtitleNegative
          : styles.subtitleBrand

  const separatorClass = compact ? styles.separatorCompact : styles.separator

  return (
    <div className={cn(styles.root, centered && styles.centered)}>
      {!!subtitle && <h3 className={cn(styles.subtitle, subtitleTypeClass)}>{subtitle}</h3>}
      <h2 className={cn(titleClassName, titleTypeClass)}>{label}</h2>
      {separator && (
        <div className={separatorClass}>
          <Separator color={color} type={type || 'brand'} />
        </div>
      )}
    </div>
  )
}

export default Title
